import { Box, ColorOptions, Image, ModBox, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { Linking } from 'react-native'
import { Accordion } from '../../comps/Accordion'
import ContactUs from '../../comps/ContactUs'
import { staticStrings } from '../../static/staticStrings'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'

export const Faqs = ({ hide = false }) => {
  if (hide) {
    return null
  }

  const resPadding = usePadding()
  const { headerSize } = useFontSize()
  const viewPortWidth = useWindowDimensions()

  const isMobile = viewPortWidth < 600
  const contact = require('../../assets/svg/emailus.svg')
  const { navigate } = useNavigation()
  return (
    <Box bg={'#F6F7FA' as ColorOptions} pv={isMobile ? 32 : 108}>
      <Box ph={resPadding}>
        <Box
          justify={'space-between'}
          align={isMobile ? 'flex-start' : 'flex-end'}
          flexDirection={isMobile ? 'column' : 'row'}>
          <Text
            title={`Frequently\nAsked Questions`}
            fontFamily={'jiotype-black'}
            fontSize={headerSize}
            color={'BLACK_21'}
            lineHeight={isMobile ? 40 : 72}
          />
          <Spacer direction={'vertical'} size={isMobile ? 24 : 0} />
          <Box flexDirection={'row'}>
            <Image width={36} height={36} source={contact} />
            <Spacer direction={'horizontal'} size={16} />
            <Box justify="center" zIndex={1000}>
              <Text
                title={'Email us for any specific questions'}
                fontSize={12}
                color={'BLACK_75'}
                fontFamily={'jiotype-medium'}
              />
              <Spacer size={4} />
              <Text
                title={staticStrings.supportEmail}
                fontSize={12}
                color={'BLUE'}
                fontFamily={'jiotype-medium'}
                textDecorationStyle={'solid'}
                textDecorationLine={'underline'}
                onPress={() => Linking.openURL(`mailto:${staticStrings.supportEmail}`)}
              />
            </Box>
          </Box>
        </Box>
        <Box pt={isMobile ? 20 : undefined}>
          <Spacer size={32} direction={'vertical'} />
          <Accordion type={'Voicebox'} size={4} screenType={'comp'} />
          <Spacer size={24} direction={'vertical'} />
          <Box
            alignSelf={'center'}
            w={118}
            h={32}
            borderWidth={1}
            borderColor={colors.JIO_PRIMARY_ALPHA as ColorOptions}
            justify={'center'}
            borderRadius={32}
            underlayColor={'TRANSPARENT'}
            onPress={() => navigate('help-center', { type: 'Voicebox' })}
            align={'center'}>
            <Text
              title={'View more...'}
              fontFamily={'jiotype-bold'}
              fontSize={14}
              color={colors.JIO_PRIMARY_ALPHA as ColorOptions}
            />
          </Box>
        </Box>
      </Box>
      <ModBox marginTop={isMobile ? 48 : 120}>
        <ContactUs type={'footer'} />
      </ModBox>
    </Box>
  )
}
